import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { homeRouteFor } from '@/utils/constants';

// Guards admin-only routes. Assumes it is nested inside ProtectedRoute, so the
// user is already authenticated; here we only check the admin role.
const AdminRoute = () => {
  const user = useAppSelector((state) => state.auth.user);

  if (user?.role !== 'admin') {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
